import { Preferences } from '@capacitor/preferences';
//import { Network } from '@capacitor/network';

interface CacheEntry<T> {
  value: T;
  timestamp: number;
  expiryMs: number;
}

export class CacheService {
  async set<T>(key: string, value: T, expiryMs: number = 60 * 60 * 24 * 1000): Promise<void> {
    console.log('Setting new cache entry...');
    const entry: CacheEntry<T> = {
      value,
      timestamp: Date.now(),
      expiryMs,
    };

    await Preferences.set({
      key,
      value: JSON.stringify(entry),
    });
  }

  async has(key: string): Promise<boolean> {
    const result = await Preferences.get({ key });
    return !!result.value;
  }

  async get<T>(key: string): Promise<{ value: T | null; isExpired: boolean }> {
    console.log('Trying to get cache...');
    const result = await Preferences.get({ key });
    if (!result.value) {
      console.log('No cache found');
      return { value: null, isExpired: false };
    }

    try {
      const entry: CacheEntry<T> = JSON.parse(result.value);
      const expired = Date.now() - entry.timestamp > entry.expiryMs;
      console.log('Found cache entry!');

      if (expired) {
        console.log('Cache expired. Returning stale value with isExpired = true.');
        return { value: entry.value, isExpired: true };
      }

      return { value: entry.value, isExpired: false };
    } catch (e) {
      console.warn(`Failed to parse cache entry for key "${key}":`, e);
      return { value: null, isExpired: false };
    }
  }

  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  }

  async clear(): Promise<void> {
    await Preferences.clear(); // Caution: clears all keys!
  }
}
